import { DRUPAL_NODE_DISPLAY, type DrupalNode } from '@commons/types/drupal';

import TestimonialNodeDefault from './Default';
import TestimonialNodeFeatured from './Featured';
import TestimonialNodeTile from './Tile';

/**
 * Type definition of a Testimonial node properties.
 */

export type TestimonialNodeProps = DrupalNode & {
  quote: string;
  name?: string;
  position?: string;
};

/**
 * Testimonial node component.
 *
 * Renders a component based on the display type.
 */

export const TestimonialNode = (props: TestimonialNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
      return <TestimonialNodeDefault {...props} />;
    case DRUPAL_NODE_DISPLAY.Featured:
      return <TestimonialNodeFeatured {...props} />;
    case DRUPAL_NODE_DISPLAY.Tile:
      return <TestimonialNodeTile {...props} />;
  }
};

export default TestimonialNode;
